// extracted by mini-css-extract-plugin
export var dateLabel = "_4d-0";
export var dateLabelError = "_4d-1";
export var fullWidth = "_4d-2";
export var smaller = "_4d-3";